import round from "../number/round";

// converts from IFCC (mmol/mol) to DCCT (%)
export default function bloodSugarToImperial(bloodSugar, precision = 1) {
  if (bloodSugar === undefined) {
    return undefined;
  }
  return round(0.09148 * bloodSugar + 2.152, precision);
}
